<template>
  <section
    :id="`${cms.scroll_id}`"
    v-editable="cms"
    :class="[name]"
    :style="mainCssVars"
  >
    <grid
      class="cursor"
      :class="['grid--container', `${name}__grid`]"
      :layout="[
        {
          size: 1,
          columns: 'repeat(12, 1fr)',
          gap: '6px',
        },
        {
          size: 2,
          columns: 'repeat(24, 1fr)',
          gap: '10px',
        },
      ]"
    >
      <grid-item
        :class="[`${name}__grid-item`, `${name}__content`]"
        :layout="[
          { size: 1, x: 1, width: 12 },
          { size: 3, x: 1, width: 24 },
        ]"
      >
        <a-heading key="heading" :cms="cms" :class="`${name}__heading`" />
        <!-- eslint-disable vue/no-v-html -->
        <div
          v-if="cms.copy"
          :class="`${name}__text`"
          v-html="$options.filters.markdown(cms.copy)"
        />
        <!--eslint-enable-->
        <component
          :is="item.component"
          v-for="item in cms.cta"
          :key="item._uid"
          v-editable="item"
          :cms="item"
          type="primary"
          :class="`${name}__cta`"
        />
      </grid-item>
      <grid-item
        v-if="cms.style_underline"
        :class="[`${name}__grid-item`, `${name}__underline`]"
        :layout="[
          { size: 1, x: 1, width: 2 },
          { size: 3, x: 1, width: 2 },
        ]"
      ></grid-item>
      <grid-item>
        {{ cms.text }}
      </grid-item>
    </grid>
    <SlideInView
      direction="up"
      slide-distance="100%"
      :threshold="0"
      :repeat="false"
      :duration="0.7"
      :class="['no-mb']"
    >
      <a-svg-logo class="big-logo" />
    </SlideInView>
  </section>
</template>

<script>
import data from '~/components/organisms/o-hero-text/o-hero-text-v2.data'
import Colors from '~/mixins/colors'
import ASvgLogo from '~/components/atoms/a-svgs/a-svg-logo'
export default {
  components: { ASvgLogo },
  mixins: [Colors],
  props: {
    cms: {
      type: Object,
      default() {
        const config = {}
        return process.env.NODE_ENV === 'development'
          ? { ...data, ...config }
          : config
      },
    },
  },

  method: {
    handleClick() {
      console.log('this happened')
      const media = document.querySelector('.m-media')
      if (media) {
        media.scrollIntoView()
      }
    },
  },

  data() {
    return {
      name: 'o-hero-text-block',
      show: false,
    }
  },

  computed: {
    mainCssVars() {
      return {
        '--bg-color': this.setColor(
          (this.cms.color_background || {}).color || '#FFFFFF',
          this.cms.color_gradient
        ),
        '--text-color': this.setColor(
          (this.cms.color_text || {}).color || '#000000'
        ),
        '--hover-color': this.setColor(
          (this.cms.color_hover || {}).color || '#C33CA8'
        ),
        '--disabled-color': this.setColor(
          (this.cms.color_disabled || {}).color || '#888b8d'
        ),
        '--underline-color': this.setColor(
          (this.cms.color_underline || {}).color || ''
        ),
        '--spacing-top': this.cms.spacing_top || '100px',
        '--spacing-bottom': this.cms.spacing_bottom || '100px',
        '--text-align': this.cms.text_align || '',
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.no-mb {
  margin-bottom: -7px !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.o-hero-text-block {
  // min-height: 533px;
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out,
    border 0.2s ease-in-out;
  background: var(--bg-color);
  border-color: var(--text-color);
  color: var(--text-color);

  ::v-deep a,
  ::v-deep .a-cta {
    color: var(--text-color);

    &:hover,
    &:active {
      color: var(--hover-color);
    }

    &:disabled,
    &.disabled {
      color: var(--disabled-color);
    }
  }

  .grid {
    align-content: center;
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  svg {
    background: rgb(0, 0, 0);
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 1) 18%,
      rgba(2, 0, 36, 0) 100%
    );
  }

  &__content {
    text-align: var(--text-align);
  }

  &__heading {
    max-width: 482px;
    margin-top: 174px !important;
    margin-bottom: 200px !important;
    font-family: 'NeueHaasGroteskText', Helvetica, Arial, sans-serif !important;
    font-size: 24px !important;
    font-style: normal !important;
    font-weight: 400 !important;
    line-height: 150% !important;
  }

  &__text {
    @include font-size(18, 25.2px);

    margin-bottom: 40px;
    letter-spacing: 1px;
  }

  &__underline {
    height: 0;
    border: 2px solid var(--underline-color);
  }
}

@include media-breakpoint-up(md) {
  .o-hero-text-block {
    &__heading {
      margin: 10px 0 40px;
      @include font-size(58, 72px);
    }
  }
}

@include media-breakpoint-up(lg) {
  .o-hero-text-block {
    // min-height: 527px;
  }
}
</style>
